import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import AnalysisForm from '../AnalysisForm';
import ReportOverviews from '../overview/ReportOverviews';
import WebsiteIndexEntryTabs from "../../deepAnalysis/websiteIndexEntry/WebsiteIndexEntryTabs";
import { AnalysisInProgressContext } from '../ContextWrapper';


export default function AnalysisPage() {
    const { isAnalysisInProgress, lastAnalysisGuid, lastAnalysisUrl } = useContext(AnalysisInProgressContext);
    const hasAnalysisParameters = lastAnalysisGuid && lastAnalysisUrl;

    return (
        <>
            {isAnalysisInProgress && hasAnalysisParameters && <Navigate to={`/analysis/report?guid=${lastAnalysisGuid}&url=${lastAnalysisUrl}`} />}
            {isAnalysisInProgress && !hasAnalysisParameters && <Navigate to="/analysis/report" />}

            {!isAnalysisInProgress && (
                <Layout.Content className="general-layout-content">
                    <AnalysisForm />
                    <WebsiteIndexEntryTabs>
                        <ReportOverviews />
                    </WebsiteIndexEntryTabs>
                </Layout.Content>
            )}
        </>
    );
}
